import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";

import { useDispatch, useSelector } from "react-redux";
import { endPoints } from "../../../config/end-points";
import useHttp from "../../../hooks/use-http";
import { authActions } from "../../../store/auth";
import { landingPageAction } from "../../../store/landingpage-store";
import LANDINGPAGES_DATA from "../../../config/landingpages";
import cuteAlert, { cuteToast } from "../../UI/cute";

const EditSalesPageModals = ({ landingPageId }) => {
  const [campDetails, setCampDetails] = useState([]);
  const [landingPage, setLandingPage] = useState(null);
  const [campLandPage, setCampLandPage] = useState(null);
  const dispatch = useDispatch();
  const { sendRequest } = useHttp();

  const camp_id = useSelector((state) => state.campaign.camp_id);

  const closemodalRef = useRef(null);

  const landingpages = LANDINGPAGES_DATA;

  const [accessPageLimit, setAccessPageLimit] = useState(10);

  const myAccess = useSelector((state) => state.auth.access);

  const handlelandingPage = (e) => {
    // console.log(page_id);
    
    cuteAlert({
      type: "question",
      title: "Do you want to proceed?",
      message: "All the changes you did on the previous landing page will be lost permanently",
      confirmText: "Yes",
      cancelText: "No",
      img: "https://engageleads-gallery.s3.us-west-2.amazonaws.com/compareshopvideo/icons/question.svg",
    }).then((e) => {
      if (e === "confirm") {
        dispatch(authActions.setLoaderStatus({ status: true }));
        sendRequest(
          {
            url: endPoints.changLandingpage,
            body: { camp_id, landingPage },
            method: "POST",
          },
          (response) => {
            // console.log(response);
            if (response.status === 200) {
              dispatch(authActions.setLoaderStatus({ status: false }));
              dispatch(landingPageAction.setPageId({ id: landingPage }));
              cuteToast({
                type: "success",
                message: "Changed Successfully",
                timer: 5000,
                title: "Landingpage",
              });
              closemodalRef.current.click();
            }
          }
        );
      } 
    });
  };

  useEffect(() => {
    if (landingPageId) {
      setLandingPage(landingPageId);

      sendRequest(
        {
          url: endPoints.getAllCampaigns,
          method: "GET",
        },
        (response) => {
          // console.log(response.body);
          if (response.body) {
            const a = response.body.map((camp) => {
              return { value: camp.id, label: camp.name };
            });

            setCampDetails(a);
          }
        }
      );
    }

    if(myAccess && (myAccess.includes("8A") || myAccess.includes("8B") || myAccess.includes("2A") || myAccess.includes("1a"))){
      setAccessPageLimit(30);
    }else if(myAccess && myAccess.includes("1A")){
      setAccessPageLimit(10);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [landingPageId,myAccess]);

  const handleLandingPage = () => {
    if (campLandPage) {
      sendRequest(
        {
          url: endPoints.updateExistingLandingPage,
          method: "POST",
          body: {
            camp_id: camp_id,
            cloneCampId: campLandPage,
          },
        },
        (response) => {
          if (response.body) {
            cuteToast({
              type: "success",
              message: "Sales Page",
              timer: 5000,
              title: "Successfully Saved",
            });
          }
        }
      );
    }
  };

  return (
    <>
      <div className="modal popup2 mxw800" id="editsalespage">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Choose Your Landing Page</h4>
              <button
                type="button"
                className="btn_close2"
                data-bs-dismiss="modal"
                ref={closemodalRef}
              >
                <i className="fa fa-close"></i>
              </button>
            </div>

            <div className="modal-body">
              <nav className="d-flex justify-content-center">
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                  <button
                    className="nav-link active"
                    id="nav-select-new-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-select-new"
                    type="button"
                    role="tab"
                    aria-controls="nav-select-new"
                    aria-selected="true"
                  >
                    Select New
                  </button>
                  <button
                    className="nav-link"
                    id="nav-profile-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#nav-profile"
                    type="button"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                  >
                    Saved Sales Pages
                  </button>
                </div>
              </nav>
              <hr />
              <div
                className="tab-content align-items-center"
                id="nav-tabContent"
              >
                <div
                  className="tab-pane  text-center fade show active"
                  id="nav-select-new"
                  role="tabpanel"
                  aria-labelledby="nav-select-new-tab"
                >
                  <div className="p-3">
                    <div className="row">
                      {landingpages.length > 0 &&
                        landingpages.filter(item => item.id <= accessPageLimit).map((page) => (
                          <div className="col-md-4 col-6 mb-4" key={page.id}>
                            <div className="frame_small_col">
                              <button
                                className={`fr_md d-flex align-items-center justify-content-center bg-transparent p-0 ${
                                  landingPage === page.id ? "active" : ""
                                }`}
                                onClick={(e) => setLandingPage(page.id)}
                              >
                                {page.id !== 1 && (
                                  <span className="select_img d-none">
                                    <img
                                      src={
                                        process.env.PUBLIC_URL +
                                        "/assets/images/check1.png"
                                      }
                                      className="img-fluid"
                                      alt="img"
                                    />
                                  </span>
                                )}
                                {page.id === 1 && (
                                  <span className="default">
                                    <img
                                      src={
                                        process.env.PUBLIC_URL +
                                        "/assets/images/default.png"
                                      }
                                      className="img-fluid"
                                      alt="img"
                                    />
                                  </span>
                                )}
                                <figure className="m-0 thumb">
                                  <img
                                    src={page.thumbnail}
                                    className="img-fluid"
                                    alt="img"
                                  />
                                </figure>
                              </button>
                              <button className="d-none pink_clor text-decoration-none bg-transparent border-0">
                                <i>
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      "/assets/images/view.png"
                                    }
                                    alt="img"
                                  />
                                </i>{" "}
                                Preview
                              </button>
                              <h6 className="mb-2">{page.name}</h6>
                            </div>
                          </div>
                        ))}
                    </div>
                  </div>

                  <div className="btn_wrap_p text-end">
                    <button
                      className="btn btn1 shadow-none"
                      onClick={handlelandingPage}
                    >
                      Save
                    </button>
                  </div>
                </div>
                <div
                  className="tab-pane fade m_t_8"
                  id="nav-profile"
                  role="tabpanel"
                  aria-labelledby="nav-profile-tab"
                >
                  <div className="p-3">
                    <div className="row">
                      <div className="col-xl-8 col-lg-8 col-md-12 m-auto">
                        {campDetails.length > 0 && (
                          <>
                            <div className="form-group">
                              <label>Select Campaign</label>
                              <Select
                                options={campDetails}
                                className=""
                                onChange={(e) => {
                                  setCampLandPage(e.value);
                                }}
                              />
                              {campLandPage && (
                                <div className="mt-2">
                                  Preview URL :{" "}
                                  <a
                                    href={`https://www.vidconnect.net/page/${campLandPage}`}
                                    target="_blank"
                                    rel="noreferrer"
                                    data-effect="solid"
                                    data-tip="Sales Page Preview"
                                  >
                                    <i className="fa fa-eye"></i>{" "}
                                    {`https://www.vidconnect.net/page/${campLandPage}`}
                                  </a>
                                </div>
                              )}
                            </div>
                            <div className="form-group text-center">
                              <button
                                className="btn btn-block"
                                value="submit"
                                onClick={handleLandingPage}
                              >
                                Submit
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditSalesPageModals;